import React from 'react';
import { Checkbox } from '../../components/ui';

const AllOptions = ({ options, selections, onOptionChange }) => {
    const validOptions = Array.isArray(options) ? options.filter(o => o && o.id != null) : [];

    const allOptions = validOptions.map((o) => (
        <Checkbox
            key={o.id}
            label={<>{o.name || 'Unknown'} <small>({o.count || 0})</small></>}
            checked={Array.isArray(selections) ? selections.some((s) => s && s.id === o.id) : false}
            // onOptionChange reads event.target.checked, as it did from the native input.
            onChange={(_checked, e) => onOptionChange(e, o)}
        />
    ))

    return (
        <div className="d-flex flex-wrap gap-3">
            {allOptions}
        </div>
    )
}

export default AllOptions